var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorPageMaskMobile = function SvgErrorPageMaskMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 377,
    viewBox: "0 0 375 377",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#f7bed1;}.d{fill:#1a2269;}.e{fill:#14165e;}.f{fill:#363896;}.g{fill:#24277e;}.h{fill:#070939;}.i{fill:#040518;}.j{fill:#f86f6f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 375,
    height: 377,
    transform: "translate(0 435)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 -435)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1899.865,0V384.344H1645.195c14.666-29.444,37.913-54.62,66.994-70.079,16.559-8.8,34.544-14.617,51.378-22.883s33.024-19.574,42.089-35.991,9.253-38.773-3.494-52.529c-12.375-13.355-32.62-15.327-50.815-14.669s-37.344,2.893-53.824-4.846c-30.22-14.192-37.386-53.971-60.434-78.126-15.981-16.748-38.759-25.017-61.042-31.29s-45.395-11.285-65.116-23.408c-18.01-11.07-32.98-29.77-34.24-50.522Z",
    transform: "translate(375 -1027.068) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.867 723.059) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 210.516)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2708.34,2045.34v125.676c0,21.724-12.2,39.4-27.2,39.4H2549.772c-11.152,0-20.222,13.137-20.222,29.288v86.12h-6.979V2239.7c0-21.724,12.2-39.4,27.2-39.4h131.367c11.149,0,20.22-13.142,20.22-29.291V2045.34Z",
    transform: "translate(-2522.57 -2005.465)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.308 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3564.416,2173.608v13.906a6.012,6.012,0,0,1-6.011,6.012h-10.661a6,6,0,0,1-4.574-2.112v0a5.979,5.979,0,0,1-1.437-3.9v-13.906Z",
    transform: "translate(-3526.103 -2112.22)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.857)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3517.468,1980.336v27.778a7.768,7.768,0,0,1-7.769,7.767h-30.844a7.768,7.768,0,0,1-7.768-7.767v-27.778Z",
    transform: "translate(-3467.306 -1974.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 53.943,
    height: 6.116,
    rx: 3.058,
    transform: "translate(53.943 6.116) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3528.628,1830.455h-7.9v-18.9a3.952,3.952,0,0,1,3.952-3.952h0a3.952,3.952,0,0,1,3.953,3.952Z",
    transform: "translate(-3508.617 -1807.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3.952,0h0A3.952,3.952,0,0,1,7.9,3.952v18.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.952A3.952,3.952,0,0,1,3.952,0Z",
    transform: "translate(33.932 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3517.468,1980.336v27.778a7.768,7.768,0,0,1-7.769,7.767h-30.844a7.768,7.768,0,0,1-7.768-7.767c33.3-2.314,36.364-27.778,36.364-27.778Z",
    transform: "translate(-3467.306 -1951.364)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 46.38,
    height: 2.24,
    transform: "translate(3.782 28.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3601.62,2050.337v16.037a7.768,7.768,0,0,1-7.769,7.767H3572.2C3594.063,2074.141,3601.62,2050.337,3601.62,2050.337Z",
    transform: "translate(-3551.457 -2009.624)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 22.682,
    height: 1.452,
    transform: "translate(15.631 64.518)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 7.905,
    height: 2.767,
    transform: "translate(12.107 20.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 7.904,
    height: 2.767,
    transform: "translate(33.932 20.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3571.542,2192.262v10.778a6.011,6.011,0,0,1-6.011,6.011H3554.87a6,6,0,0,1-4.574-2.111h0c16.616,2.038,19.154-14.677,19.154-14.677Z",
    transform: "translate(-3533.229 -2127.745)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.308)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3825.277,552.47V563H3615.744c-11.152,0-20.223,13.685-20.223,30.51V731.864h-6.981V593.509c0-22.63,12.2-41.039,27.2-41.039Z",
    transform: "translate(-3565.059 -612.958)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 91.135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3564.416,1115.75v-13.906a6.012,6.012,0,0,0-6.011-6.012h-10.661a6,6,0,0,0-4.574,2.111v0a5.98,5.98,0,0,0-1.437,3.9v13.906Z",
    transform: "translate(-3526.103 -1095.832)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.789)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3517.468,1231.477V1203.7a7.768,7.768,0,0,0-7.769-7.767h-30.844a7.768,7.768,0,0,0-7.768,7.767v27.778Z",
    transform: "translate(-3467.306 -1195.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 53.943,
    height: 6.116,
    rx: 3.058,
    transform: "translate(53.943 41.661) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3517.468,1231.477V1203.7a7.768,7.768,0,0,0-7.769-7.767h-30.844a7.768,7.768,0,0,0-7.768,7.767c33.3,2.314,36.364,27.778,36.364,27.778Z",
    transform: "translate(-3467.306 -1179.143)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 46.38,
    height: 2.24,
    transform: "translate(3.782 50.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3601.62,1219.736V1203.7a7.768,7.768,0,0,0-7.769-7.767H3572.2C3594.063,1195.932,3601.62,1219.736,3601.62,1219.736Z",
    transform: "translate(-3551.457 -1179.143)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 22.682,
    height: 1.452,
    transform: "translate(15.631 15.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3571.542,1112.621v-10.777a6.012,6.012,0,0,0-6.011-6.012H3554.87a6,6,0,0,0-4.574,2.111v0c16.616-2.038,19.154,14.676,19.154,14.676Z",
    transform: "translate(-3533.229 -1095.832)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.106 137.298)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3165.568,1569.313h-14.361a1.977,1.977,0,0,1,0-3.954h14.361a1.977,1.977,0,1,1,0,3.954Z",
    transform: "translate(-3149.23 -1565.359)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3345.5,1389.377a1.977,1.977,0,0,1-1.976-1.977v-14.361a1.977,1.977,0,1,1,3.953,0V1387.4A1.977,1.977,0,0,1,3345.5,1389.377Z",
    transform: "translate(-3343.527 -1371.062)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.545 9.545)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3217.98,1441.79a1.97,1.97,0,0,1-1.4-.579l-9.865-9.865a1.977,1.977,0,0,1,2.8-2.8l9.865,9.865a1.977,1.977,0,0,1-1.4,3.375Z",
    transform: "translate(-3206.138 -1427.971)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.804 81.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.227)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3962.248,1854.11h14.361a1.977,1.977,0,0,1,0,3.954h-14.361a1.977,1.977,0,1,1,0-3.954Z",
    transform: "translate(-3960.271 -1854.11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.227)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3853.576,1962.784a1.976,1.976,0,0,1,1.976,1.977v14.361a1.977,1.977,0,1,1-3.954,0v-14.361A1.977,1.977,0,0,1,3853.576,1962.784Z",
    transform: "translate(-3851.598 -1962.784)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.178 13.178)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M3932.145,1932.68a1.97,1.97,0,0,1,1.4.579l9.866,9.865a1.977,1.977,0,1,1-2.8,2.8l-9.866-9.865a1.977,1.977,0,0,1,1.4-3.375Z",
    transform: "translate(-3930.168 -1932.68)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorPageMaskMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-page-mask-mobile.1b38f579686c07edee6da95ef994edc6.svg";